export default __webpack_public_path__ + "static/media/Logo_Icon.f5f21362.svg";